import { BaseDialog } from "@/types/dialog";
import { Dialog, DialogContent } from "../ui/dialog";
import { Button } from "../ui/button";
import { Text } from "../ui/text";
import { overlay } from "overlay-kit";
import useQuickStartStore from "@/stores/quick-start";

const QuickStartCloseDialog = ({ isOpen, onClose }: BaseDialog) => {
  const { setIsVisible } = useQuickStartStore();
  const handleOk = () => {
    localStorage.setItem("quickStartClose", "true");
    setIsVisible(false);
    overlay.closeAll();
  };
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="rounded-[10px] w-[380px] h-[472px] flex flex-col gap-[48px]">
        <div className="flex flex-col gap-[32px] px-10 pt-10">
          <div className="w-[300px] h-[229px] flex justify-center items-center">
            <img
              src="/images/quick-start-close-image.png"
              alt="image"
              width={300}
              height={229}
            />
          </div>
          <Text variant={"title-lg"} className="text-center">
            You can view the <span className="underline">Quick start</span>{" "}
            again from the header menu.
          </Text>
        </div>
        <div className="flex justify-center pb-[24px] px-[24px]">
          <Button variant={"primary"} size={"lg"} onClick={handleOk}>
            <Text variant={"title-md"} className="text-white">
              Ok
            </Text>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuickStartCloseDialog;
